import { Link } from 'react-router-dom';
import { SCRAPE_DATA } from '../data/scrapeData';
import { GLOBAL_COMPANY_INFO, getResizedImageUrl } from '../lib/cms';

export default function AboutPage() {
  return (
    <div className="bg-[#F8FAFC] pt-28 pb-20">
      
      {/* Header Banner */}
      <section className="bg-[#1D352E] text-white py-16 mb-16 -mt-[10px]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <span className="text-white text-sm font-semibold tracking-wider uppercase">
              Om Maler Carsten Janum ApS
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight">
              {SCRAPE_DATA.omOs.mainHeading}
            </h1>
            <p className="text-gray-200 text-lg">
              {SCRAPE_DATA.omOs.subHead}
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          
          {/* Left Text Column */}
          <div className="lg:col-span-7 space-y-8 lg:sticky lg:top-28">
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200 space-y-6">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#1D352E]">
                Personlig service og mere end 20 års erfaring
              </h2>

              <div className="space-y-4 text-gray-700 leading-relaxed text-base">
                <p>{SCRAPE_DATA.omOs.body1}</p>
                <p>{SCRAPE_DATA.omOs.body2}</p>
                <p>{SCRAPE_DATA.index.paragraphs[1]}</p>
                <p>{SCRAPE_DATA.index.paragraphs[2]}</p>
              </div>
            </div>

            {/* Values / Work approach */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm space-y-3">
                <div className="w-10 h-10 rounded-lg bg-[#1D352E] text-white flex items-center justify-center text-lg">
                  <i className="fa-regular fa-handshake" aria-hidden="true" />
                </div>
                <h3 className="text-lg font-bold text-[#1D352E]">Troværdighed & Aftaler</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Hos os er en aftale en aftale. Vi møder til tiden, leverer det aftalte arbejde og efterlader altid stedet pænt og ryddeligt.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm space-y-3">
                <div className="w-10 h-10 rounded-lg bg-[#1D352E] text-white flex items-center justify-center text-lg">
                  <i className="fa-regular fa-paintbrush" aria-hidden="true" />
                </div>
                <h3 className="text-lg font-bold text-[#1D352E]">Grundigt Forarbejde</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Et flot og langtidsholdbart malerresultat afhænger af forarbejdet. Vi spartler, sliber og klargør altid overfladerne ordentligt.
                </p>
              </div>
            </div>
          </div>

          {/* Right Image & Info Card */}
          <div className="lg:col-span-5 space-y-8">
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-slate-200">
              <img
                src={getResizedImageUrl('https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240101-221222.jpg', 1000, 85)}
                alt="Carsten Janum - Malermester"
                className="w-full h-96 sm:h-[480px] object-cover object-top"
              />
              <div className="p-6 space-y-4">
                <h3 className="text-xl font-bold text-[#1D352E]">Virksomhedsoplysninger</h3>
                <ul className="space-y-3 text-sm text-gray-700 border-t border-gray-100 pt-4">
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-building text-[#65237e] mt-0.5" />
                    <span><strong>Firma:</strong> {GLOBAL_COMPANY_INFO.company_name}</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-location-dot text-[#65237e] mt-0.5" />
                    <span><strong>Adresse:</strong> {GLOBAL_COMPANY_INFO.address}</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fa-solid fa-id-card text-[#65237e] mt-0.5" />
                    <span><strong>CVR-nr:</strong> {GLOBAL_COMPANY_INFO.cvr}</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <i className="fa-solid fa-phone text-[#65237e]" />
                    <span><strong>Telefon:</strong> <a href={`tel:${GLOBAL_COMPANY_INFO.phone_raw}`} className="hover:text-[#65237e] font-medium nowrap-contact">{GLOBAL_COMPANY_INFO.phone}</a></span>
                  </li>
                  <li className="flex items-center gap-3">
                    <i className="fa-solid fa-envelope text-[#65237e]" />
                    <span><strong>E-mail:</strong> <a href={`mailto:${GLOBAL_COMPANY_INFO.email}`} className="hover:text-[#65237e] font-medium nowrap-contact">{GLOBAL_COMPANY_INFO.email}</a></span>
                  </li>
                </ul>

                <div className="pt-2">
                  <Link
                    to="/kontakt"
                    className="block w-full py-3 text-center text-sm font-semibold text-white bg-[#65237e] hover:bg-[#521b67] rounded-xl shadow-md transition-colors"
                  >
                    Kontakt Carsten i dag
                  </Link>
                </div>
              </div>
            </div>

            {/* 3Byggetilbud Rating Card */}
            <div className="bg-[#1D352E] text-white rounded-2xl p-6 shadow-lg border border-white/10 space-y-4">
              <div className="flex items-center justify-between">
                <span className="text-xs uppercase font-semibold text-amber-300 tracking-wider">Topvurderet Leverandør</span>
                <i className="fa-solid fa-award text-amber-400 text-xl" />
              </div>

              <div className="flex items-baseline gap-2">
                <span className="text-4xl font-extrabold text-amber-400">4,9</span>
                <span className="text-gray-300 text-sm">/ 5.0 på 3Byggetilbud.dk</span>
              </div>

              <div className="flex items-center text-amber-400 gap-1 text-base">
                <i className="fa-solid fa-star" />
                <i className="fa-solid fa-star" />
                <i className="fa-solid fa-star" />
                <i className="fa-solid fa-star" />
                <i className="fa-solid fa-star" />
              </div>

              <p className="text-xs text-gray-200 leading-relaxed">
                Baseret på 18 verificerede anmeldelser fra glade kunder, der roser arbejdet, fleksibiliteten og den personlige service.
              </p>

              <a
                href="https://www.3byggetilbud.dk/leverandoer/maler-carsten-janum-aps/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-xs font-semibold text-amber-300 hover:text-amber-200 transition-colors pt-1"
              >
                <span>Læs alle 18 anmeldelser på 3Byggetilbud.dk</span>
                <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" />
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
